import styled from 'styled-components';
import { linearGradient, radialGradient } from 'lib/helpers/helpers';
import { getStaticAsset } from 'lib/helpers/resources';
import { ButtonStyle } from 'components/Button/Button.style';
import { AboutInfo, BodyText, Heading1 } from '../Text/Text.style';
import Colors from '../../styles/colors';

export const AboutHeadingSectionStyle = styled.div`
  position: relative;
  height: 202px;

  & > * {
    position: relative;
  }

  @media (min-width: ${props => props.theme.breakpoints.mdMin}) {
    height: 260px;
  }
`;

const AboutHeadingBackgroundUrl = `https://cldnr.talpa.network/talpa-network/image/fetch/h_260,w_auto/${getStaticAsset(
  'static/images/img-header-large@3x.jpg'
)}`;

export const AboutHeadingBackgroundStyle = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  background: url(${AboutHeadingBackgroundUrl}) right 20% center / cover no-repeat;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: ${props =>
      linearGradient(
        props.theme.gradients.about.headingVertical.direction,
        props.theme.gradients.about.headingVertical.stops
      )};
  }

  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: ${props =>
      linearGradient(
        props.theme.gradients.about.headingHorizontal.small.direction,
        props.theme.gradients.about.headingHorizontal.small.stops
      )};
    mask-image: ${props =>
      linearGradient(
        props.theme.gradients.about.headingVertical.direction,
        props.theme.gradients.about.headingVertical.stops
      )};
  }

  @media (min-width: ${props => props.theme.breakpoints.mdMin}) {
    background: url(${AboutHeadingBackgroundUrl}) right 45% top / 139% no-repeat;

    &::after {
      background: ${props =>
        linearGradient(
          props.theme.gradients.about.headingHorizontal.medium.direction,
          props.theme.gradients.about.headingHorizontal.medium.stops
        )};
    }
  }

  @media (min-width: ${props => props.theme.breakpoints.lgMin}) {
    background: none;

    &::before {
      right: 0;
      left: auto;
      width: 60%;
      background: url(${AboutHeadingBackgroundUrl}) right top / cover no-repeat;
    }

    &::after {
      background: ${props =>
        linearGradient(
          props.theme.gradients.about.headingHorizontal.large.direction,
          props.theme.gradients.about.headingHorizontal.large.stops
        )};
      mask-image: none;
    }
  }
`;

export const AboutHeadingTextWrapperStyle = styled.div`
  grid-column: 1 / 7;
  align-self: center;
  width: 275px;

  @media (min-width: ${props => props.theme.breakpoints.mdMin}) {
    position: relative;
    left: 10%;
    width: 310px;
  }

  @media (min-width: ${props => props.theme.breakpoints.lgMin}) {
    grid-column: 1 / 13;
    left: auto;
    width: auto;
  }
`;

export const AboutMoreSectionStyle = styled.div`
  position: relative;
  padding-bottom: 80px;
  background-color: ${Colors.nero};

  @media (min-width: ${props => props.theme.breakpoints.mdMin}) {
    padding-bottom: 50px;
    background-image: ${props =>
      linearGradient(
        props.theme.gradients.about.more.background.medium.direction,
        props.theme.gradients.about.more.background.medium.stops
      )};
  }

  @media (min-width: ${props => props.theme.breakpoints.lgMin}) {
    padding-bottom: 80px;
    background-image: ${props =>
      linearGradient(
        props.theme.gradients.about.more.background.large.direction,
        props.theme.gradients.about.more.background.large.stops
      )};
  }
`;

export const AboutMoreDevicesStyle = styled.div`
  img {
    display: block;
    width: 100%;
    position: relative;
    margin: 35px auto 0;

    @media (min-width: ${props => props.theme.breakpoints.mdMin}) {
      width: 60%;
      margin-top: 80px;
    }

    @media (min-width: ${props => props.theme.breakpoints.lgMin}) {
      width: 100%;
      max-width: 520px;
      margin-top: 65px;
    }
  }
`;

export const AboutMoreTextStyle = styled.div`
  margin-top: 30px;
  margin-bottom: 50px;

  @media (min-width: ${props => props.theme.breakpoints.mdMin}) {
    margin-top: 40px;
    margin-bottom: 80px;
  }

  @media (min-width: ${props => props.theme.breakpoints.lgMin}) {
    margin-top: 60px;
  }
`;

export const AboutMoreCornerGradientStyle = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  width: 150px;
  height: 150px;
  background-image: ${props =>
    radialGradient(props.theme.gradients.about.more.corner.direction, props.theme.gradients.about.more.corner.stops)};
`;

export const AboutAccountSectionStyle = styled.div`
  position: relative;
  overflow: hidden;
  background-image: ${props =>
    linearGradient(
      props.theme.gradients.about.account.small.direction,
      props.theme.gradients.about.account.small.stops
    )};

  @media (min-width: ${props => props.theme.breakpoints.mdMin}) {
    background-image: ${props =>
      linearGradient(
        props.theme.gradients.about.account.medium.direction,
        props.theme.gradients.about.account.medium.stops
      )};
  }

  @media (min-width: ${props => props.theme.breakpoints.lgMin}) {
    background-image: ${props =>
      linearGradient(
        props.theme.gradients.about.account.large.direction,
        props.theme.gradients.about.account.large.stops
      )};
  }
`;

export const AboutAccountTitleStyle = styled(Heading1)`
  @media (min-width: ${props => props.theme.breakpoints.mdMin}) {
    max-width: 452px;
  }
`;

export const AboutAccountTextWrapperStyle = styled.div`
  grid-column: 1 / 7;
  margin: 35px 0 80px;

  @media (min-width: ${props => props.theme.breakpoints.mdMin}) {
    grid-column: 1 / 13;
    margin-top: 80px;
  }

  @media (min-width: ${props => props.theme.breakpoints.lgMin}) {
    margin: 120px 0;
  }

  @media (min-width: 1200px) {
    grid-column: 2 / 13;
  }
`;

export const AboutAccountButtonWrapperStyle = styled.div`
  position: relative;
  max-width: inherit;
  margin: 26px auto 0;

  ${ButtonStyle} {
    padding-right: 0;

    &:hover {
      opacity: 0.95;
    }
  }

  span {
    width: 100%;
    display: block;
    line-height: 48px;
    color: ${Colors.white};
    font-size: 16px;
    justify-content: center;
    font-weight: 700;
  }

  @media (min-width: ${props => props.theme.breakpoints.smMid}) {
    max-width: 288px;
  }

  @media (min-width: ${props => props.theme.breakpoints.mdMin}) {
    margin: 33px 0 0;
  }
`;

export const AboutAccountBulletWrapperStyle = styled.div`
  display: flex;
  margin-top: 5px;
  ${AboutAccountTextWrapperStyle} &:first-of-type {
    margin-top: 25px;
  }
`;

export const AboutAccountBulletStyle = styled(BodyText)`
  width: 100%;
  margin-top: 5px;
  padding-left: 4px;

  @media (min-width: ${props => props.theme.breakpoints.mdMin}) {
    max-width: 350px;
  }
`;

const AboutAccountImageUrl = `https://cldnr.talpa.network/talpa-network/image/fetch/h_572,w_auto/${getStaticAsset(
  'static/images/img-account-large.png'
)}`;

export const AboutAccountImageStyle = styled.div`
  display: none;
  position: absolute;
  background: url(${AboutAccountImageUrl}) bottom -19px right / contain no-repeat;

  @media (min-width: ${props => props.theme.breakpoints.mdMin}) {
    display: block;
    bottom: 0;
    right: 0;
    width: 48%;
    height: 338px;
  }
  @media (min-width: ${props => props.theme.breakpoints.lgMin}) {
    display: block;
    top: 0;
    width: 57%;
    height: 572px;
    background-position: bottom right;
  }
`;

export const AboutInfoSectionStyle = styled.div`
  padding: 48px 0 38px;
  overflow: hidden;
  background-color: ${Colors.nero};

  @media (min-width: ${props => props.theme.breakpoints.mdMin}) {
    padding: 80px 0 70px;
  }

  @media (min-width: ${props => props.theme.breakpoints.lgMin}) {
    padding: 80px 0 70px;
  }
`;

export const AboutFaqStyle = styled.div`
  padding: 32px 18px;
  background-image: ${props =>
    linearGradient(props.theme.gradients.about.faq.direction, props.theme.gradients.about.faq.stops)};
  border-radius: 4px;

  ${Heading1} {
    margin-bottom: 25px;
  }
`;

export const AboutFaqTextStyle = styled(BodyText)`
  max-width: 420px;
  margin: 0 auto;
  text-align: center;
`;

export const AboutFaqButtonWrapperStyle = styled.div`
  position: relative;
  width: 200px;
  margin: 20px auto 0;
  line-height: 48px;
  color: ${Colors.white};
  border-radius: 4px;
  border: 2px solid ${Colors.brownGrey};
  font-size: 16px;
  text-align: center;
  font-weight: 700;
  cursor: pointer;

  @media (min-width: ${props => props.theme.breakpoints.mdMin}) {
    width: 220px;
  }
`;

export const AboutAboutImageStyle = styled.div`
  width: 234px;
`;

export const AboutAddressStyle = styled(AboutInfo)`
  margin-top: 41px;

  @media (min-width: ${props => props.theme.breakpoints.mdMin}) {
    margin-top: 72px;
  }
`;

export const AboutMediadienstStyle = styled(AboutInfo)`
  width: 248px;
  margin-top: 33px;

  @media (min-width: ${props => props.theme.breakpoints.mdMin}) {
    width: auto;
    max-width: 430px;
    margin-top: 72px;
  }
`;

export const AboutAccountSeparatorWrapperStyle = styled.div`
  position: relative;
  margin-left: auto;
`;

export const AboutAccountSeparatorSvgStyle = styled.div`
  width: 15px;
  height: 100%;
  position: relative;
  left: -5px;
`;

export const AboutAccountSeparatorStyle = styled.div`
  display: flex;
  width: 40px;
  height: 48px;
  background-color: ${Colors.white};
  border-radius: 0 4px 4px 0;
`;

export const AboutAccountArrowWrapperStyle = styled.div`
  margin: auto;
  width: 50%;
`;

export const AboutAccountArrowStyle = styled.div`
  margin: auto;
  width: 50%;
  border-top: 5px solid transparent;
  border-bottom: 5px solid transparent;
  border-left: 8px solid ${Colors.greenishTeal};
`;
